function init_datadome(){
    !function(a,b,c,d,e,f){a.ddjskey=e;a.ddoptions=f||null;var m=b.createElement(c),n=b.getElementsByTagName(c)[0];m.async=1,m.src=d,n.parentNode.insertBefore(m,n)}(window,document,"script","https://js.datadome.co/tags.js","3ACEBA20A5E1BB7C78506502845CE0", { ajaxListenerPath: true });
}

export default init_datadome;